import { configureStore } from "@reduxjs/toolkit";
import generalInformationReducer from "./components/entities/general-information/generalInformationSlice";
// import bankDetailsReducer from "./components/entities/bank-details/bankDetailsSlice";
import addressesReducer from "./components/entities/address/addressesSlice";
import counterReducer from "./components/counter/counterSlice";
import myEntityReducer from "./Pages/MyEntityDashboard/myEntityDashboardSlice";
import inviteModalReducer from "./components/settings/users/invite-modal/InviteModalSlice";
// import documentsGridReducer from "./components/entities/documents-grid/documentsGridSlice";
import globalEntitiesReducer from "./components/global-entities/globalEntitiesSlice";
import personnelReducer from "./components/entities/key-personnel/personnelSlice";
import shareHoldersReducer from "./components/share-holders/shareHoldersSlice";
import loginSlice from "./Pages/Login/loginSlice";
import entityOnboardReducer from "./Pages/EntityOnboard/components/entityOnboardSlice";
import formReducer from "./Pages/EntityOnboard/components/formSlice";
import directorsRegFormReducer from "./components/directors-form/directorsRegFormSlice";
import directorsReducer from "./components/directors-form/directorsSlice";
import generalTempFormReducer from "./components/entities/general-information/tempFormDataSlice";
import lspOnboardReducer from "./Pages/Lsp/actions/lspSlice";
import employeReducer from "./Pages/EmployeeRegistry/actions/employeeSlice";
import tasksSlice from "./Pages/Process/actions/tasksSlice";
import milestoneSlice from "./Pages/Process/actions/milestoneSlice";
import processSlice from "./Pages/Process/actions/processSlice";
import attachmentsSlice from "./Pages/Process/actions/attachmentsSlice";
import entityPlusReducer from "./components/entities/entity-plus/entityPlusSlice";
export const store = configureStore({
  reducer: {
    generalInformation: generalInformationReducer,
    // bankDetails: bankDetailsReducer,
    addresses: addressesReducer,
    personnel: personnelReducer,
    counter: counterReducer,
    myentitydashboard: myEntityReducer,
    inviteusers: inviteModalReducer,
    // documentsGrid: documentsGridReducer,
    globalEntities: globalEntitiesReducer,
    shareHolders: shareHoldersReducer,
    login: loginSlice,
    onboarding: entityOnboardReducer,
    form: formReducer,
    directorsRegForm: directorsRegFormReducer,
    directors: directorsReducer,
    generalTempForm: generalTempFormReducer,
    lsponboarding: lspOnboardReducer,
    tasks: tasksSlice,
    milestones: milestoneSlice,
    process: processSlice,
    attachments: attachmentsSlice,
    entityPlusinfo: entityPlusReducer,
    employeeregister: employeReducer,
  },
});
